var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "j-modal",
    {
      attrs: {
        title: _vm.title,
        width: 800,
        visible: _vm.visible,
        confirmLoading: _vm.confirmLoading,
        switchFullscreen: "",
        cancelText: "关闭",
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
    },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: { model: _vm.model, rules: _vm.validatorRules },
            },
            [
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "name",
                    label: "机构名称",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入机构名称" },
                    model: {
                      value: _vm.model.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "name", $$v)
                      },
                      expression: "model.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "phone",
                    label: "手机号码",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入手机号码" },
                    model: {
                      value: _vm.model.phone,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "phone", $$v)
                      },
                      expression: "model.phone",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "shareRatio",
                    label: "分成比例（%）",
                  },
                },
                [
                  _c("a-input-number", {
                    model: {
                      value: _vm.model.shareRatio,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "shareRatio", $$v)
                      },
                      expression: "model.shareRatio",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }